import { render, staticRenderFns } from "./Squeeze.vue?vue&type=template&id=e688d98a&"
var script = {}
import style0 from "./Squeeze.vue?vue&type=style&index=0&id=e688d98a&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIHeader: require('/opt/build/repo/components/UI/Header.vue').default,CartBannerTop: require('/opt/build/repo/components/Cart/BannerTop.vue').default,UIBreadcrumb: require('/opt/build/repo/components/UI/Breadcrumb.vue').default,UIFooter: require('/opt/build/repo/components/UI/Footer.vue').default})
